import { UPDATE_FAVOURITE_BOARD } from "./actionTypes";

export default ({boardId, title, objectType}) => ({
  type: UPDATE_FAVOURITE_BOARD,
  payload: {
    boardId,
    title, 
    objectType
  },
});